import React from 'react';
import FinalForm from '@/Framework/UI/Organisms/FinalForm';
import {
  PORTFOLIO_REVIEW_UNKNOWNS_FIELD_ARRAY,
  PORTFOLIO_REVIEW_UNKNOWNS_FORM,
} from './constants';
import ReviewUnknownsFields from './ReviewUnknownsFields';
import { useStepFormContext } from '@/finsight/application/PortfolioMonitor/StepFormContext';
import useGetPositions from '@/finsight/ui/components/portfolioMonitor/PortfolioContent/common/useGetPositions';

import formStyles from '@/finsight/ui/components/portfolioMonitor/PortfolioContent/PortfolioForm/formStyles.scss';

const ReviewUnknownsTable = (props) => {
  const { positions } = useGetPositions();
  const { goNext } = useStepFormContext();

  const submit = async () => {
    goNext();
  };

  return (
    <FinalForm
      name={ PORTFOLIO_REVIEW_UNKNOWNS_FORM }
      className={ formStyles.virtualListContainer }
      dataTest={ PORTFOLIO_REVIEW_UNKNOWNS_FORM }
      render={ () => <ReviewUnknownsFields { ...props } /> }
      onSubmit={ submit }
      initialValues={ { [PORTFOLIO_REVIEW_UNKNOWNS_FIELD_ARRAY]: positions } }
    />
  );
};

export default ReviewUnknownsTable;
